document.addEventListener("DOMContentLoaded", function () {
  //console.log("✅ ev-variant-updates.js loaded");

  let variantData = {};
  let variantMetafields = {};
  let isAutoSelecting = false;

  // Fetch variant data
  fetch(window.location.pathname + ".json")
    .then((res) => res.json())
    .then((data) => {
      data.product.variants.forEach((variant) => {
        variantData[variant.id] = {
          id: variant.id,
          sku: variant.sku,
          title: variant.title
        };
      });
    });

  // Get metafields from script tag
  const metafieldsScript = document.getElementById("variant-metafields-data");
  if (metafieldsScript) {
    try {
      variantMetafields = JSON.parse(metafieldsScript.textContent);
    } catch (e) {
      console.warn("Failed to parse variant metafields JSON");
    }
  }

  // Raw map from Liquid JSON:
  // { "123": "AW,GB", "124": null, ... }
  let variantBlockedCountriesRaw = {};
  const blockedScript = document.getElementById("ev-variant-blocked-countries");
  if (blockedScript) {
    try {
      variantBlockedCountriesRaw = JSON.parse(blockedScript.textContent);
    } catch (e) {
      console.warn("Failed to parse ev-variant-blocked-countries JSON");
    }
  }

  // Current country from ev-localization
  let currentCountry = { iso_code: null, name: null };
  const locScript = document.getElementById("ev-localization");
  if (locScript) {
    try {
      const loc = JSON.parse(locScript.textContent);
      if (loc?.country) currentCountry = loc.country;
    } catch (e) {
      console.warn("Failed to parse ev-localization JSON");
    }
  }

  function getBlockedIsoList(variantId) {
    const raw =
      variantBlockedCountriesRaw?.[String(variantId)] ??
      variantBlockedCountriesRaw?.[variantId] ??
      null;

    if (Array.isArray(raw)) {
      return raw
        .filter((x) => typeof x === "string")
        .map((s) => s.trim().toUpperCase())
        .filter(Boolean);
    }

    if (!raw || typeof raw !== "string") return [];

    // Support "AW,GB" or "AW, GB" or any other rogue characters
    return raw
      .replace(/\r?\n/g, ",")
      .split(",")
      .map((s) => s.trim().toUpperCase())
      .filter(Boolean);
  }

  function isVariantBlockedInCountry(variantId) {
    const iso = currentCountry?.iso_code;
    if (!variantId || !iso) return false;
    return getBlockedIsoList(variantId).includes(String(iso).toUpperCase());
  }

  function setQuantityDisabled(disabled) {
    const qtyRoot = document.querySelector('[id^="Quantity-Form-"]');
    if (!qtyRoot) return;

    // Disable native inputs/buttons
    qtyRoot.querySelectorAll('input, select, textarea, button').forEach((el) => {
      el.disabled = !!disabled;
    });

    //qtyRoot.style.pointerEvents = disabled ? "none" : "";
    qtyRoot.style.opacity = disabled ? "0.5" : "";
    //qtyRoot.style.cursor = disabled ? "not-allowed" : "";

      // Create/remove overlay blocker
      let blocker = qtyRoot.querySelector(".ev-qty-blocker");
      if (disabled) {
        if (!blocker) {
          blocker = document.createElement("div");
          blocker.className = "ev-qty-blocker";
          // Ensure parent can position absolute children
          const computedPosition = window.getComputedStyle(qtyRoot).position;
          if (computedPosition === "static") {
            qtyRoot.style.position = "relative";
          }

          // Apply all CSS inline for testing
          //blocker.style.display = "block";
          //blocker.style.position = "absolute";
          //blocker.style.inset = "0";
          //blocker.style.cursor = "not-allowed";
          //blocker.style.background = "transparent";
          //blocker.style.zIndex = "5";

          qtyRoot.appendChild(blocker);
        }
      } else {
        blocker?.remove();
      }
  }

  function setPriceInfoHidden(hidden) {
    // The custom "unit price/subtotal" block highlighted
    const calc = document.querySelector(".ev-price-calculation");
    if (calc) calc.style.display = hidden ? "none" : "";

    // Hide Shopify’s price block (only if it exists in this section)
    const priceBlock = document.querySelector('[id^="price-template-"]');
    if (priceBlock) priceBlock.style.display = hidden ? "none" : "";
  }

  function updatePurchaseButtonState(variantId) {
    const atcBtn = document.querySelector(".ev-add-to-cart");
    const enquireBtn = document.querySelector(".ev-enquire-button");
    const msg = document.querySelector(".ev-variant-unavailable-message");
    const countryName = msg?.querySelector(".ev-country-name");

    if (!atcBtn || !enquireBtn || !msg) return;

    const blocked = isVariantBlockedInCountry(variantId);

    if (blocked) {
      atcBtn.style.display = "none";
      enquireBtn.style.display = "";
      msg.style.display = "";
      if (countryName) countryName.textContent = currentCountry?.name || "your country";
    } else {
      atcBtn.style.display = "";
      enquireBtn.style.display = "none";
      msg.style.display = "none";
      if (countryName) countryName.textContent = "";
    }
  }

  // 🔒 Guard so the "variant change" work runs once per actual change
  let lastHandledVariantId = null;

  function updateHeroButtonState(variantId) {
    const heroPurchase = document.querySelector(".ev-hero-purchase");
    const heroEnquire = document.querySelector(".ev-hero-enquire");
    if (!heroPurchase || !heroEnquire) return;

    // Respect market-level gating first
    const marketHandle = (() => {
      const locScript = document.getElementById("ev-localization");
      if (!locScript) return null;
      try {
        return JSON.parse(locScript.textContent)?.market?.handle || null;
      } catch (e) {
        return null;
      }
    })();

    const isSellingMarket = marketHandle && marketHandle !== "default";
    if (!isSellingMarket) {
      heroPurchase.style.display = "none";
      heroEnquire.style.display = "";
      return;
    }

    // Default market: swap based on variant blocking
    const blocked = isVariantBlockedInCountry(variantId);

    if (blocked) {
      heroPurchase.style.display = "none";
      heroEnquire.style.display = "";
      setQuantityDisabled(true);
      setPriceInfoHidden(true);
    } else {
      heroPurchase.style.display = "";
      heroEnquire.style.display = "none";
      setQuantityDisabled(false);
      setPriceInfoHidden(false);
    }
  }

  function handleSelectedVariantChange() {
    const variantId = getSelectedVariantId();
    if (!variantId || variantId === lastHandledVariantId) return;

    lastHandledVariantId = variantId;

    updateVariantDetails(variantId);
    updatePurchaseButtonState(variantId);

    // Swap purchase button in pdp hero if variant blocked in current country
    updateHeroButtonState(variantId);
  }

  // Get currently selected variant ID
  function getSelectedVariantId() {
    const input = document.querySelector('input[name="id"]');
    return input?.value || null;
  }

  // Update SKU and Colour Title
  function updateVariantDetails(variantId) {
    if (!variantId || !variantData[variantId]) return;

    const variant = variantData[variantId];
    const colourLabel = variantMetafields[variantId]?.colourLabel || null;

    document.querySelectorAll('[data-ev-variant-sku]').forEach((el) => {
      if (variant.sku) {
        el.textContent = variant.sku;
        el.classList.remove("visibility-hidden");
      } else {
        el.textContent = "";
        el.classList.add("visibility-hidden");
      }
    });

    document.querySelectorAll('[data-ev-variant-title]').forEach((el) => {
      if (colourLabel) {
        el.textContent = colourLabel;
        el.classList.remove("visibility-hidden");
      } else {
        el.textContent = variant.title;
        el.classList.remove("visibility-hidden");
      }
    });
  }

  // Swap add to cart button for the enquire button if variant is blocked in the current country
  function updatePurchaseButtonState(variantId) {
    const blocked = isVariantBlockedInCountry(variantId);

    const atcBtn = document.querySelector(".ev-add-to-cart");
    const enquireBtn = document.querySelector(".ev-enquire-button");
    const msg = document.querySelector(".ev-variant-unavailable-message");
    const countryName = msg?.querySelector(".ev-country-name");

    // If buy-buttons aren't rendered (e.g. non-default market), just bail safely.
    if (!atcBtn || !enquireBtn || !msg) return;

    if (blocked) {
      atcBtn.style.display = "none";
      enquireBtn.style.display = "";
      msg.style.display = "";
      if (countryName) countryName.textContent = currentCountry?.name || "your country";
    } else {
      atcBtn.style.display = "";
      enquireBtn.style.display = "none";
      msg.style.display = "none";
      if (countryName) countryName.textContent = "";
    }
  }

  // Auto-select first visible + enabled Size/Finish pills
  function autoSelectFirstAvailablePills() {
    if (isAutoSelecting) return;
    isAutoSelecting = true;
    //console.log("🔁 Running autoSelectFirstAvailablePills...");
    document.querySelectorAll(".product-form__input--pill").forEach((fieldset) => {
      const visibleInputs = Array.from(
        fieldset.querySelectorAll('input[type="radio"]:not(.disabled)')
      ).filter((input) => {
        const label = document.querySelector(`label[for="${input.id}"]`);
        return label && label.offsetParent !== null;
      });

      if (!visibleInputs.length) return;

      const alreadySelected = fieldset.querySelector('input[type="radio"]:checked');
      if (!alreadySelected || !visibleInputs.includes(alreadySelected)) {
        visibleInputs[0].checked = true;
        visibleInputs[0].dispatchEvent(new Event("change", { bubbles: true }));
        //console.log("✅ Auto-selected pill:", visibleInputs[0].value);
      }
    });
    isAutoSelecting = false;
  }

  // Immediately hide unavailable pills
  function hideUnavailablePills() {
    //console.log("🚫 Hiding unavailable pills...");
  
    document.querySelectorAll(".product-form__input--pill").forEach((fieldset) => {
      fieldset.querySelectorAll('input[type="radio"]').forEach((input) => {
        const label = document.querySelector(`label[for="${input.id}"]`);
        if (!label) return;
  
        if (input.classList.contains("disabled")) {
          label.style.display = "none";
        } else {
          label.style.display = "";
        }
      });
    });
  }

  /* GJ20250730
   * Use this retry function if unavailable pills remain on the page and don't get hidden every time...
   * Also uncomment out waitForVisiblePillsAndThenRun in handleSwatchChange function underneath
   
  function waitForVisiblePillsAndThenRun(callback, attempt = 0) {
    const maxAttempts = 10;
    const delay = 50; // ms
  
    const pillsExist = !!document.querySelector(".product-form__input--pill input");
  
    if (pillsExist) {
      callback();
    } else if (attempt < maxAttempts) {
      setTimeout(() => {
        waitForVisiblePillsAndThenRun(callback, attempt + 1);
      }, delay);
    } else {
      console.warn("⚠️ Failed to detect pills after multiple attempts.");
      callback(); // Run anyway as fallback
    }
  }
  */

  // When colour swatch is changed
  function handleSwatchChange(e) {
    console.log("🎯 Swatch changed:", e.target);
  
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        //waitForVisiblePillsAndThenRun(() => {
          hideUnavailablePills();
          autoSelectFirstAvailablePills();
          handleSelectedVariantChange();
        //});
      });
    });
  }

  function attachSwatchListeners() {
    //console.log("📌 attachSwatchListeners ran");
    document.querySelectorAll('input[type="radio"][data-variant-id]:not([data-listener-attached])').forEach((input) => {
      input.addEventListener("change", handleSwatchChange);
      input.setAttribute("data-listener-attached", "true");
    });
  }

    // Watch for variant picker block re-rendering (debounced)
  
    let swatchObserver = null;
  
    function setupMutationObserver() {
      const target = document.querySelector('[id^="MainProduct-"]') || document.body;
      let mutationLock = false;
      let lastRun = 0;
    
      swatchObserver = new MutationObserver((mutations) => {
        const now = Date.now();

        const hasRelevantChange = mutations.some((m) => {
          if (m.type !== "childList") return false;
        
          return [...m.addedNodes].some((node) => {
            if (!(node instanceof HTMLElement)) return false;
        
            // ✅ Trigger only when Shopify re-inserts the variant-selects block
            return node.id?.startsWith("variant-selects-template");
          });
        });
    
        if (!hasRelevantChange) return;
    
        // Block if mutation happened less than 200ms ago (debounce)
        if (mutationLock || now - lastRun < 200) {
          return;
        }
    
        mutationLock = true;
        lastRun = now;
        //console.count("🧼 MutationObserver triggered");
    
        swatchObserver.disconnect(); // Temporarily stop observing
    
        // Let DOM settle for 2 frames
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            //console.log("🔧 Safe DOM update sequence");
    
            attachSwatchListeners();
            hideUnavailablePills();
            autoSelectFirstAvailablePills();
            handleSelectedVariantChange();
    
            mutationLock = false;
    
            // Reconnect observer
            swatchObserver.observe(target, {
              childList: true,
              subtree: true
            });
          });
        });
      });
    
      // Start observing
      swatchObserver.observe(target, {
        childList: true,
        subtree: true
      });
    }

  // Also watch the hidden input[name="id"] for direct variant switching
  const variantInput = document.querySelector('input[name="id"]');
  if (variantInput) {
    const observer = new MutationObserver(() => {
      handleSelectedVariantChange();
    });
    observer.observe(variantInput, { attributes: true, attributeFilter: ["value"] });
  }

  // Fallback on form change
  document.querySelector("form[action*='/cart/add']")?.addEventListener("change", () => {
    handleSelectedVariantChange();
  });

  // Initial boot
  attachSwatchListeners();
  hideUnavailablePills(); // hide pills immediately
  autoSelectFirstAvailablePills();
  handleSelectedVariantChange();

  // 🔧 Start safe observer AFTER boot
  setupMutationObserver();

/*
  const debugObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      [...mutation.addedNodes, ...mutation.removedNodes].forEach((node) => {
        if (!(node instanceof HTMLElement)) return;
  
        console.group("🔍 Mutation detected");
        console.log("Type:", mutation.type);
        console.log("Target:", mutation.target);
        console.log("Node:", node);
        console.log("Node outerHTML:", node.outerHTML?.slice(0, 500));
        console.groupEnd();
      });
    });
  });
  
  const debugTarget = document.querySelector('[id^="MainProduct-"]') || document.body;
  
  debugObserver.observe(debugTarget, {
    childList: true,
    subtree: true,
  });
*/

});
